import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppShell } from "@/components/AppShell";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Claim from "@/pages/Claim";
import PaymentSuccess, { PaymentCancel } from "@/pages/PaymentResult";
import Dashboard from "@/pages/Dashboard";
import SendLetter from "@/pages/SendLetter";
import Mailbox from "@/pages/Mailbox";
import MailDetail from "@/pages/MailDetail";
import Receipts from "@/pages/Receipts";
import Admin from "@/pages/Admin";
import Verify from "@/pages/Verify";
import LegalPage from "@/pages/LegalPage";
import { TermsGate } from "@/components/TermsGate";
import YourData from "@/pages/YourData";
import Enterprise from "@/pages/Enterprise";
import Bulk from "@/pages/Bulk";
import Guide from "@/pages/Guide";
import AddressBook from "@/pages/AddressBook";
import BatchDetail from "@/pages/BatchDetail";
import ApiKeys from "@/pages/ApiKeys";
import ApiDocs from "@/pages/ApiDocs";
import Team from "@/pages/Team";
import Join from "@/pages/Join";
import Insights from "@/pages/Insights";
import ConfirmReplyTo from "@/pages/ConfirmReplyTo";
import AuditTrail from "@/pages/AuditTrail";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <TermsGate />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/claim/:token" element={<Claim />} />
            <Route path="/enterprise" element={<Enterprise />} />
            <Route path="/developers" element={<ApiDocs />} />
            <Route path="/join/:token" element={<Join />} />
            <Route path="/confirm-reply-to/:token" element={<ConfirmReplyTo />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/verify/o/:orgSlug" element={<Verify />} />
            <Route path="/verify/o/:orgSlug/:certId" element={<Verify />} />
            <Route path="/verify/:certId" element={<Verify />} />
            {["terms", "privacy", "gdpr", "cookies"].map((s) => <Route key={s} path={`/${s}`} element={<LegalPage slug={s} />} />)}
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
              <Route path="/app" element={<Dashboard />} />
              <Route path="/app/send" element={<SendLetter />} />
              <Route path="/app/mailbox" element={<Mailbox />} />
              <Route path="/app/mail/:id" element={<MailDetail />} />
              <Route path="/app/receipts" element={<Receipts />} />
              <Route path="/app/your-data" element={<YourData />} />
              <Route path="/app/bulk" element={<Bulk />} />
              <Route path="/app/guide" element={<Guide />} />
              <Route path="/app/address-book" element={<AddressBook />} />
              <Route path="/app/bulk/:id" element={<BatchDetail />} />
              <Route path="/app/api" element={<ApiKeys />} />
              <Route path="/app/team" element={<Team />} />
              <Route path="/app/insights" element={<Insights />} />
              <Route path="/app/audit" element={<AuditTrail />} />
            </Route>
            <Route element={<ProtectedRoute admin><AppShell /></ProtectedRoute>}>
              <Route path="/admin" element={<Admin />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
